// extracted by mini-css-extract-plugin
export default {"container":"footer_container__tTpaG","section":"footer_section__0NwCj","title":"footer_title__NO+Fr"};